import { JsonRPCService } from '@xengage/gw-portals-transport-js';
import { getProxiedServiceUrl } from '@xengage/gw-portals-url-js';

export default class TwiaBillingService {

    static getAccountBillingSummary(accountNumber, additionalHeaders = {}) {
        return JsonRPCService.send( getProxiedServiceUrl('gatewayBilling'), 'getAccountBillingDetails',   [accountNumber],  additionalHeaders );
    }

    static getAccountBillingSummaryData(accountNumber, additionalHeaders = {}) {
        return JsonRPCService.send( getProxiedServiceUrl('gatewayBilling'), 'getAccountBillingSummary',  [accountNumber],  additionalHeaders );
    }

    static getPaymentGroupPaymentInformation(accountNumber, streamInternalId, additionalHeaders = {}  ) {
        return JsonRPCService.send( getProxiedServiceUrl('gatewayBilling'),'getPaymentGroupPaymentInformation',   [accountNumber, streamInternalId],   additionalHeaders   );
    }

    static setPaymentGroupPaymentInformation( accountNumber, streamInternalId, paymentMethod, additionalHeaders = {}) {
        return JsonRPCService.send( getProxiedServiceUrl('gatewayBilling'),'setPaymentGroupPaymentInformation',  [accountNumber, streamInternalId, paymentMethod], additionalHeaders);
    }

    static getPolicyBillingSummary(policyNumber, additionalHeaders = {}) {
        return JsonRPCService.send( getProxiedServiceUrl('gatewayBilling'), 'getPolicyBillingSummary', [policyNumber], additionalHeaders );
    }

    static getPaymentSummaryByPolicyNumber(policyNumber, additionalHeaders = {}){
        return JsonRPCService.send( getProxiedServiceUrl('tfpabilling'), 'getPaymentSummaryByPolicyNumber', [policyNumber],  additionalHeaders ); 
    }

    /** *******************************************************
     *  Billing Payments Services
     */

    static makeDirectBillPayment(  accountNumber, request, additionalHeaders = {}) {
        return JsonRPCService.send( getProxiedServiceUrl('gatewayBillingDirectBillPayment'), 'makeDirectBillPayment', [accountNumber, request], additionalHeaders );
    }

    static getSyncedPaymentInstruments(accountNumber, includeOneTime, additionalHeaders = {}) {
        // US22304 - EMERGENCY - Automatic Refresh of Payment Methods when Funding Account already exists message is received.
        return JsonRPCService.send(getProxiedServiceUrl('twiabilling'), 'getSyncedPaymentInstruments', [accountNumber, includeOneTime, false], additionalHeaders);
    }

    static getAllSyncedPaymentInstruments(includeOneTime, includeInactive, additionalHeaders = {}) {
        // US22304 - EMERGENCY - Automatic Refresh of Payment Methods when Funding Account already exists message is received.
        return JsonRPCService.send(getProxiedServiceUrl('twiabilling'), 'getSyncedPaymentInstrumentsForCurrentUser', [includeOneTime, includeInactive], additionalHeaders);
    }

    static getAvailableAccountNumbers( additionalHeaders = {}){
        return JsonRPCService.send(getProxiedServiceUrl('twiabilling'), 'getAvailableAccountNumbers', [], additionalHeaders);
    }

    static   getPaymentInstrumentsForPolicy(policyNumber, includeOneTime, additionalHeaders = {}) {
        return JsonRPCService.send(getProxiedServiceUrl('twiabilling'), 'getPaymentInstrumentsForPolicy', [policyNumber, includeOneTime], additionalHeaders);
    }

    static getInvoiceStreamAutoPayData(invoiceStreamId, includeOneTime, additionalHeaders = {}){
        return JsonRPCService.send(getProxiedServiceUrl('twiabilling'), 'getInvoiceStreamAutoPayData', [invoiceStreamId, includeOneTime, false], additionalHeaders);
    }

    static getPaymentInstrumentSessionTransfer(identifier, entryPoint, lob, useProfile, state, insuredName, emailID, additionalHeaders = {}){
        return JsonRPCService.send(getProxiedServiceUrl('twiabilling'), 'getPaymentInstrumentSessionTransfer', [identifier, entryPoint, lob, useProfile, state, insuredName, emailID], additionalHeaders );
    }

    static getEditPaymentInstrumentSessionTransfer(identifier, entryPoint, lob, token, state, additionalHeaders = {}) {
        // US12920 CE - Manage Payment Method
        return JsonRPCService.send(getProxiedServiceUrl('twiabilling'), 'getEditPaymentInstrumentSessionTransfer',  [identifier, entryPoint, lob, token, state], additionalHeaders );
    }

    static  deletePaymentInstrument(identifier, lob, token, additionalHeaders = {}) {
        // US12920 CE - Manage Payment Method
        return JsonRPCService.send(getProxiedServiceUrl('twiabilling'), 'deletePaymentInstrument', [identifier, lob, token], additionalHeaders);
    }

    static makePolicyPayment(tokenNumber, policyNumber, amount, overrideDupPayment, additionalHeaders = {}) {
        return JsonRPCService.send(getProxiedServiceUrl('twiabilling'), 'makePolicyPayment', [tokenNumber, policyNumber, amount, overrideDupPayment], additionalHeaders);
    }

    static getACICardFee(publicID, policyNumber, amount, additionalHeaders = {}){
        return JsonRPCService.send(getProxiedServiceUrl('twiabilling'), 'getACITotalAmountwithFee', [publicID, policyNumber, amount], additionalHeaders);
    }

    static createPaymentInstrument(securityStamp, vendorFundingMethod, paymentInstrument, additionalHeaders = {}) {
        return JsonRPCService.send(getProxiedServiceUrl('twiabilling'), 'createPaymentInstrument', [securityStamp, vendorFundingMethod, paymentInstrument], additionalHeaders );
    }

    static updatePaymentInstrument(securityStamp, vendorFundingMethod, paymentInstrument, additionalHeaders) {
        return JsonRPCService.send(getProxiedServiceUrl('twiabilling'), 'updatePaymentInstrument', [securityStamp, vendorFundingMethod, paymentInstrument], additionalHeaders);
    }

    // US12926 get fees for offers
    static getACICardFeeForOffer(paymentInstrumentPublicId, lobCode, uwCompany, totalAmount, additionalHeaders = {}){
        return JsonRPCService.send(getProxiedServiceUrl('twiabilling'), 'getACICardFeeForOffer', [paymentInstrumentPublicId, lobCode, uwCompany, totalAmount], additionalHeaders
        );
    }

    // US12919 pay balance and enable autopay
    static payBalanceAndEnableAutoPay(paymentInstrumentPublicId, streamPublicId, additionalHeaders = {}){
        return JsonRPCService.send(getProxiedServiceUrl('twiabilling'), 'payBalanceAndEnableAutoPay',  [paymentInstrumentPublicId, streamPublicId], additionalHeaders );
    }

    // US12919 disable autopay
    static disableAutoPay(streamPublicId, additionalHeaders = {}) {
        return JsonRPCService.send(getProxiedServiceUrl('twiabilling'), 'disableAutoPay', [streamPublicId], additionalHeaders); 
    }

    // US18915 log an error message to BC
    static logErrorMessage(message, additionalHeaders = {}) {
        return JsonRPCService.send(getProxiedServiceUrl('twiabilling'), 'logErrorMessage', [message], additionalHeaders); 
    }

    // US21726 - [Continued] TECH DEBT: Store ACI Payloads in BC Service Call History Table
    static saveFundingPortalResponse(identifier, message, additionalHeaders = {}) {
        return JsonRPCService.send(getProxiedServiceUrl('twiabilling'), 'saveFundingPortalResponse', [identifier, message], additionalHeaders);
    }

    static canAddPaymentInstrumentsToAccount(accountNumber, additionalHeaders = {}) {
        // US20204 CE - ACI Maximum Payment Method Limit
        return JsonRPCService.send(getProxiedServiceUrl('twiabilling'), 'canAddPaymentInstrumentsToAccount', [accountNumber], additionalHeaders);
    }

    // * US12928 - CE - Renewal Offers
    static getOverridingPaymentInstrument(policyNumber, additionalHeaders = {}) {
        return JsonRPCService.send(getProxiedServiceUrl('twiabilling'), 'getOverridingPaymentInstrument', [policyNumber], additionalHeaders);
    }

    // US30268 sync payment instruments to deactivate as necessary
    static syncPaymentInstruments_TWIA(additionalHeaders = {}) {
        return JsonRPCService.send(getProxiedServiceUrl('twiabilling'), 'syncPaymentInstruments_TWIA', [], additionalHeaders);
    }
}
